import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAction from "./AbstractAction.js";

/**
 * Action providing `underline`.
 */
export default class UnderlineAction extends AbstractAction {
	getMarks() {
		return {
			underline: { toDOM: () => ["u"], parseDOM: [{ tag: "u" }] },
		};
	}

	getMenuItems({ schema }) {
		return [this._makeUnderlineItem(schema.marks.underline)];
	}

	_makeUnderlineItem(mark) {
		return this._makeMarkItem({
			order: 24,
			title: _("Toggle underline"),
			icon: this._makeIcon({ cssClass: "fa fa-underline" }),
			mark,
		});
	}
}
